/* src/views/logements/ficheCache.js — LE CACHE DE LA FICHE (lot 4, décision
   Dimitri 2026-08-28 : « les appels en série — corrige maintenant »).

   Deux maux traités :
   1. le MÊME appel lancé deux fois (Instructions et Livret chargent chacun
      livret_admin_data) → déduplication des appels EN VOL ;
   2. le re-chargement à chaque bascule d'onglet → petite durée de vie (TTL),
      assez courte pour rester honnête, assez longue pour naviguer.

   Toute MUTATION doit invalider sa clé avant de relire (les recharger() des
   contrôleurs le font) — un cache qui survit à une écriture est un menteur. */

const entrees = new Map() // clé → { promesse, valeur, quand }

export async function lireAvecCache(cle, ttlMs, lecteur) {
  const e = entrees.get(cle)
  const maintenant = Date.now()
  if (e) {
    if (e.promesse) return e.promesse // appel en vol : on s'y greffe
    if (maintenant - e.quand < ttlMs) return e.valeur
  }
  const promesse = (async () => {
    try {
      const valeur = await lecteur()
      entrees.set(cle, { valeur, quand: Date.now() })
      return valeur
    } catch (err) {
      entrees.delete(cle) // jamais de cache d'échec
      throw err
    }
  })()
  entrees.set(cle, { promesse, quand: maintenant })
  return promesse
}

export function invaliderCache(prefixe) {
  for (const cle of entrees.keys()) {
    if (cle.startsWith(prefixe)) entrees.delete(cle)
  }
}
